function rotationMatrix(sn, cs) {
    var beta = ([[cs, sn, 0, 0, 0, 0],
        [-sn, cs, 0, 0, 0, 0],
        [0, 0, 1, 0, 0, 0],
        [0, 0, 0, cs, sn, 0],
        [0, 0, 0, -sn, cs, 0],
        [0, 0, 0, 0, 0, 1]])

    // var beta = ([[cs, sn, 0, 0, 0, 0],
    //     [-sn, cs, 0, 0, 0, 0],
    //     [0, 0, 1, 0, 0, 0],
    //     [0, 0, 0, cs, sn, 0],
    //     [0, 0, 0, -sn, cs, 0],
    //     [0, 0, 0, 0, 0, 1]])

    //console.log(beta)
    return beta
}

export default rotationMatrix